import {Injectable} from '@angular/core';
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ProfileImageComponent} from "../../../components/profile-image/profile-image.component";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ProfileImageService {
    private modalRef: NgbModalRef;

    constructor(private modalService: NgbModal,
                private modalConfig: NgbModalConfig,
                private http: HttpClient) {
        modalConfig.backdrop = 'static';
        modalConfig.keyboard = false;
    }

    openModal() {
        this.modalRef = this.modalService.open(ProfileImageComponent, {size:'400px'});
    }

    closeModal() {
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    updatePhoto(payload): Observable<any> {
        const url = `${environment.apiUser}/avatar/save`;
        return this.http.post(url, payload);
    }
}
